module.exports = __webpack_public_path__ + "assets/bc6c0727107458aa1f7c4598b44e65ce.mp4";